<div id="grievances-submit" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h1 class="title">Submit a Grievance</h1>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College is committed to providing a safe, fair, and conducive environment for all students. If you have any grievance or complaint, you may submit it using the online form below. All complaints are handled with utmost confidentiality.
    </p>

    <hr class="divider">

    <div class="row g-3 mt-2">
      <div class="col-md-6">
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSeCSNcOSeDD8xJ1PcnIpQEfjQ0-p9KyKmFJeGfXpDW5XK8gGA/viewform" target="_blank" class="pdf-download-btn w-100 text-center">
          <i class="fa fa-edit me-2"></i>Submit Grievance Online
        </a>
      </div>
    </div>

    <h4 class="section-subtitle mt-4">Grievance Redressal Process</h4>
    <ul class="list-styled mt-3">
      <li>Student submits grievance through the online form or in person</li>
      <li>Grievance is received and acknowledged within 3 working days</li>
      <li>Committee reviews and investigates the complaint</li>
      <li>Resolution is communicated to the student within 30 days</li>
      <li>If unsatisfied, appeal can be made to the Ombudsperson</li>
    </ul>

  </div>
</div>
